import dayjs from "dayjs";
const avg = (a) => a.length ? a.reduce((x, y) => x + y, 0) / a.length : null;
function overrideTrend(sessions) {
  const used = sessions.filter((s) => s.path === "emergency" && s.postSuds != null);
  const months = Array.from({ length: 6 }, (_, i) => dayjs().subtract(5 - i, "month").format("YYYY-MM"));
  const trend = months.map((m) => {
    const inMonth = used.filter((s) => dayjs(s.timestamp).format("YYYY-MM") === m);
    return { m, mins: avg(inMonth.filter((s) => s.emergencySeconds).map((s) => s.emergencySeconds / 60)), n: inMonth.length };
  });
  const timed = trend.filter((t) => t.mins != null);
  const maxMins = Math.max(1, ...timed.map((t) => t.mins));
  let message = null;
  if (timed.length >= 2) {
    const first = timed[0].mins;
    const last = timed[timed.length - 1].mins;
    message = last < first - 0.2 ? `You're settling faster \u2014 about ${(first - last).toFixed(1)} min quicker than in ${dayjs(timed[0].m).format("MMMM")}.` : last > first + 0.2 ? "Settling has taken a little longer lately. That's okay \u2014 hard months happen. Keep showing up." : "You're settling at a steady pace each month.";
  }
  return { used, trend, timed, maxMins, message };
}
export {
  overrideTrend
};
